const timeline_config_store = {
    subscribers:{},
    options:{
        active:false
    },
    getOption(option){
        return this.options[option]
    },
    setOption(option, value){
        this.options[option] = value
        this.publish('SET_OPTION', {option:option, value:value})
    },
    subscribe(topic, callback){
        if(!this.subscribers[topic]){
            this.subscribers[topic] = []
        }
        this.subscribers[topic].push(callback)
    },
    publish(topic, data){
        if(this.subscribers[topic]){
            this.subscribers[topic].forEach(callback => {
                callback(data);
            });
        }
    }
}

export default timeline_config_store